export enum RecordType {
    READY,
    START,
    STOP,
    PLAY,
    PAUSE,
    RESUME
}
